import { NoticeDto } from "src/dtos/notice/noticeDto";
import { formatDate } from "src/utils/string/stringUtil";


export interface SYS4120_R01Dto extends NoticeDto{
}

export const defaultSYS4120_R01Dto: SYS4120_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	noticeNo:		'',				// 공지번호(기본키)
	category:		'',				// 공지분류
	noticeTitle:	'',				// 제목
	writerDt:		new Date(),		// 등록일자
	writerEmpNo:	'',				// 등록자
	writerEmpNm:	'',				// 등록자명
	noticeComment:	'',				// 공지내용
	noticeFromDt:	formatDate(new Date()),	// 게시 시작일
	noticeEndDt:	formatDate(new Date()),	// 게시 종료일
	noticeDateRange:	{
		from: new Date(),
		to: new Date(),
	},
	topNotice:		'N',			// 최상단 공지 여부
	remark:			'',				// 비고


	inserted: false,
	isModified: false
}
